module.exports = __webpack_public_path__ + "static/media/liz.578a9e31.jpg";